<template>
    <div class="settlement">
<!--        <el-card >-->
<!--            <el-breadcrumb separator="/">-->
<!--                <el-breadcrumb-item :to="{ name: 'workspace' }">首页</el-breadcrumb-item>-->
<!--                <el-breadcrumb-item>订单管理</el-breadcrumb-item>-->
<!--                <el-breadcrumb-item>采购订单</el-breadcrumb-item>-->
<!--            </el-breadcrumb>-->
<!--        </el-card>-->
        <main class="content">
            <el-card>
                <el-form :inline="true" :model="searchForm" :disabled="loading" size="mini">
                    <el-form-item label="采购合同号" label-width="100px">
                        <el-input v-model="searchForm.purchaseOrderNo" placeholder="采购合同号" size="mini" clearable style="width: 150px"></el-input>
                    </el-form-item>
                    <el-form-item label="采购订单编号" label-width="100px">
                        <el-input v-model="searchForm.orderNo" placeholder="采购订单编号" size="mini" clearable style="width: 150px"></el-input>
                    </el-form-item>
                    <el-form-item label="采购方" label-width="70px"  >
                        <el-select filterable  collapse-tags clearable size="mini" mul v-model="searchForm.purchaser" placeholder="采购方"  style="width: 200px">
                            <el-option
                                v-for="item in companys"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="收货人" label-width="70px">
                        <el-input v-model="searchForm.consignee" placeholder="收货人" size="mini" clearable style="width: 150px"></el-input>
                    </el-form-item>
                    <el-form-item label="下单日期" label-width="70px"  >
                        <el-date-picker
                            v-model="searchForm.orderDate"
                            type="daterange"
                            align="right"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            clearable>
                            </el-date-picker>
                    </el-form-item>
                    <el-form-item label="发票状态" label-width="70px">
                        <el-select v-model="searchForm.invoice" placeholder="发票状态" size="mini" clearable>
                            <el-option label="未开票" value="0"></el-option>
                            <el-option label="已开票" value="1"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="订单状态" label-width="70px">
                        <el-select v-model="searchForm.status" placeholder="订单状态" size="mini" clearable>
                            <el-option
                                v-for="item in optionStatus"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="订单ID" label-width="70px">
                        <el-input v-model="searchForm.id" placeholder="订单ID" size="mini" clearable style="width: 150px"></el-input>
                    </el-form-item>
                    <el-form-item label="订单编号" label-width="70px">
                        <el-input v-model="searchForm.orderNo1" placeholder="订单编号" size="mini" clearable style="width: 150px"></el-input>
                    </el-form-item>
                    <el-form-item label="客户订单编号" label-width="100px">
                        <el-input v-model="searchForm.customerOrderId" placeholder="客户订单编号" size="mini" clearable style="width: 150px"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="doSearch()" size="mini">查询</el-button>
                    </el-form-item>
                </el-form>
                <div ref="tablePosition" align="right">
                    <RightToolBar :showSearch="showSearch" @reDrawTable="reDrawTable"
                        :columns="dropCol" ></RightToolBar>
                </div>
                <el-table
                    size="mini"
                    stripe
                    :key = "updateTable"
                    row-key="id"
                    ref="purchaseTable"
                    :data="tableData"
                    v-loading="loading"
                    @selection-change="handleSelectionChange"
                    :height="tableConfig.height"
                    style="width: 100%">
                    <el-table-column type="selection" width="55" fixed/>
                    <el-table-column width="auto"  :min-width="160"
                                     class-name="drag"
                                     v-if="dropCol[0].isShow"
                                     :key="dropCol[0].id"
                                     :prop="dropCol[0].prop"
                                     :label="dropCol[0].label"></el-table-column>
                    <el-table-column width="auto" :min-width="160"
                                     class-name="drag"
                                     v-if="dropCol[1].isShow"
                                     :key="dropCol[1].id"
                                     :prop="dropCol[1].prop"
                                     :label="dropCol[1].label"></el-table-column>
                    <el-table-column width="auto" :min-width="160"
                                     class-name="drag"
                                     v-if="dropCol[2].isShow"
                                     :key="dropCol[2].id"
                                     :prop="dropCol[2].prop"
                                     :label="dropCol[2].label"></el-table-column>
                    <el-table-column width="auto" :min-width="160"
                                     class-name="drag"
                                     v-if="dropCol[3].isShow"
                                     :key="dropCol[3].id"
                                     :prop="dropCol[3].prop"
                                     :label="dropCol[3].label"></el-table-column>
                    <el-table-column width="auto" :min-width="160"
                                     class-name="drag"
                                     v-if="dropCol[4].isShow"
                                     :key="dropCol[4].id"
                                     :prop="dropCol[4].prop"
                                     :label="dropCol[4].label"></el-table-column>
                    <el-table-column width="auto" min-width="200"
                                     class-name="drag"
                                     v-if="dropCol[5].isShow"
                                     :key="dropCol[5].id"
                                     :prop="dropCol[5].prop"
                                     :label="dropCol[5].label"></el-table-column>
                    <el-table-column width="auto" :min-width="80"
                                     class-name="drag"
                                     v-if="dropCol[6].isShow"
                                     :key="dropCol[6].id"
                                     :prop="dropCol[6].prop"
                                     :label="dropCol[6].label"></el-table-column>
                    <el-table-column width="auto" :min-width="120"
                                     class-name="drag"
                                     v-if="dropCol[7].isShow"
                                     :key="dropCol[7].id"
                                     :prop="dropCol[7].prop"
                                     :label="dropCol[7].label"></el-table-column>
                    <el-table-column width="auto" :min-width="200"
                                     class-name="drag"
                                     v-if="dropCol[8].isShow"
                                     :key="dropCol[8].id"
                                     :prop="dropCol[8].prop"
                                     :label="dropCol[8].label"></el-table-column>
                    <el-table-column width="auto" :min-width="120"
                                     class-name="drag"
                                     v-if="dropCol[9].isShow"
                                     :key="dropCol[9].id"
                                     :prop="dropCol[9].prop"
                                     :label="dropCol[9].label"></el-table-column>
                    <el-table-column width="auto" :min-width="120"
                                     class-name="drag"
                                     v-if="dropCol[10].isShow"
                                     :key="dropCol[10].id"
                                     :prop="dropCol[10].prop"
                                     :label="dropCol[10].label"></el-table-column>
                    <el-table-column
                            v-if="dropCol[11].isShow"
                            :key="dropCol[11].id"
                            :prop="dropCol[11].prop"
                            :label="dropCol[11].label"
                            width="120" align="center">
                        <template slot-scope="scope">
                            <el-tag v-if="!scope.row.invoice">未开票</el-tag>
                            <el-tag v-else>已开票</el-tag>

                        </template>

                    </el-table-column>
                    <el-table-column
                            v-if="dropCol[12].isShow"
                            :key="dropCol[12].id"
                            :prop="dropCol[12].prop"
                            :label="dropCol[12].label"
                            width="auto" min-width="120" align="center">
                    </el-table-column>
                    <el-table-column
                            v-if="dropCol[13].isShow"
                            :key="dropCol[13].id"
                            :prop="dropCol[13].prop"
                            :label="dropCol[13].label"
                            width="auto" min-width="180" align="center">
                    </el-table-column>
                     <el-table-column fixed="right" width="100" align="center"
                                      class-name="drag"
                                      v-if="dropCol[14].isShow"
                                      :key="dropCol[14].id"
                                      :prop="dropCol[14].prop"
                                      :label="dropCol[14].label">
                         <template slot-scope="scope">
                             <el-tag size="mini">{{ scope.row.statusShow }}</el-tag><i class="el-icon-edit" style="color:#409eff;margin-left:8px;cursor: pointer;" @click="handleShowEditStatusDialog(scope.row)"></i>
                         </template>
                     </el-table-column>
<!--                         <el-table-column width="auto" prop="saleOrder" label="采购合同号" :min-width="160"></el-table-column>-->
<!--                         <el-table-column width="auto" prop="order" label="采购订单号" :min-width="160"></el-table-column>-->
<!--                         <el-table-column width="auto" prop="supplierOrder" label="供应商订单号" :min-width="160"></el-table-column>-->
<!--                         <el-table-column width="auto" prop="purchaser" label="采购方" min-width="200"></el-table-column>-->
<!--                         <el-table-column width="auto" prop="untaxedPrice" label="未税总价(元)" :min-width="120" align="right" header-align="center"></el-table-column>-->
<!--                         <el-table-column width="auto" prop="price" label="含税总价(元)" :min-width="120" align="right" header-align="center"></el-table-column>-->
<!--                         <el-table-column fixed="right" prop="status" label="状态" width="100" align="center">-->

                    <el-table-column width="200" align="right" fixed="right" header-align="center"
                                     v-if="dropCol[15].isShow"
                                     :key="dropCol[15].id"
                                     :prop="dropCol[15].prop"
                                     :label="dropCol[15].label">
                        <template slot="header" slot-scope="header">
                            <span><el-button @click="handleShowSelectedInvoiceDialog" size="mini" type="primary">交票</el-button></span>
                            <el-dropdown style="margin-left: 8px;" @command="exportOrderDialogNew">
                                <el-button type="primary" size="mini">
                                    导出<i class="el-icon-arrow-down el-icon--right"></i>
                                </el-button>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item command="all">导出全部</el-dropdown-item>
                                    <el-dropdown-item command="selected">导出已选</el-dropdown-item>
                                    <el-dropdown-item command="supplier">导出对账单</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                            <!-- <span>操作
                                <el-tooltip placement="top">
                                    <i class="el-icon-question"></i>
                                    <div slot="content">订货合同导出本采购结算单号相同供应商的所有商品</div>
                                </el-tooltip>
                            </span> -->
                        </template>
                        <template slot-scope="scope">
                            <el-button type="text" size="mini" @click="handleToReviewDetail(scope.row)">详情</el-button>
                            <el-divider direction="vertical"></el-divider>
                            <el-button type="text" size="mini" @click="handleToDeliver(scope.row)">签收单</el-button>
                            <el-divider direction="vertical"></el-divider>

                            <el-dropdown size="mini" style="margin-left: 10px;" >
                                <div style="">
                                     <span class="el-dropdown-link" style="font-size: 12px;vertical-align: middle;line-height: 28px;" >
                                    更多<i class="el-icon-arrow-down el-icon--right"></i>
                                  </span>
                                </div>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item>
                                        <el-button type="text" size="mini" @click="handleUploadDeliver(scope.row)" style="width: 100%;text-align: left;">上传签收单</el-button>

                                    </el-dropdown-item>
                                    <el-dropdown-item>
                                        <el-button type="text" size="mini" @click="exportProcurementContract(scope.row.id)" :disabled="!scope.row.saleOrder" style="width: 100%;text-align: left;">订货合同</el-button>
                                    </el-dropdown-item>
                                    <el-dropdown-item>
                                        <el-button type="text" size="mini" @click="handleShowInvoiceDialog(scope.row)" style="width: 100%;text-align: left;">交票</el-button>
                                    </el-dropdown-item>
                                    <el-dropdown-item divided v-if="scope.row.customerOrderId">
                                        <el-button type="text" size="mini" @click="handleToDeliveryNote(scope.row)" style="width: 100%;text-align: left;">福田送货单</el-button>
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </template>
                    </el-table-column>
                </el-table>
                <div style="text-align: center;padding-top: 20px" v-if="total > 0">
                    <el-pagination
                        background
                        layout="sizes,prev, pager, next"
                        :total="total"
                        :page-sizes="[10, 20, 50, 100]"
                        :page-size="pageSize"
                        @size-change="onSizeChange"
                        @current-change="onPageChange"
                        :current-page="currentPage"
                        @prev-click="onPageChange"
                        @next-click="onPageChange">
                    </el-pagination>
                </div>
            </el-card>
        </main>
        <el-dialog title="上传供货单" :visible.sync="visibleUploadDeliver" width="800px" :close-on-click-modal="false">
            <el-upload
                :action="`/api/admin/purchaseOrder/uploadDeliver/${uploadDeliverPOId}`"
                list-type="picture-card"
                :file-list="deliverImages"
                :on-success="onUploadSuccess"
                :auto-upload="true">
                    <i slot="default" class="el-icon-plus"></i>
                    <div slot="file" slot-scope="{file}">
                    <img
                        class="el-upload-list__item-thumbnail"
                        :src="file.url" alt=""
                    >
                    <span class="el-upload-list__item-actions">
                        <span
                        class="el-upload-list__item-preview"
                        @click="handlePictureCardPreview(file)"
                        >
                        <i class="el-icon-zoom-in"></i>
                        </span>
                    </span>
                    </div>
            </el-upload>
        </el-dialog>
        <el-dialog title="预览" :visible.sync="dialogPreviewVisible">
            <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
        <el-dialog title="修改状态" :visible.sync="dialogEditStatusVisible" width="400px">
            <el-form ref="editStatusForm" :model="editStatusForm" :rules="rules" label-width="90px" size="mini">
                <el-form-item label="采购订单号" prop="order">
                    <el-input v-model="editStatusForm.order" placeholder="请输入订单编号" size="mini" disabled clearable></el-input>
                </el-form-item>
                <el-form-item label="状态" prop="status">
                    <el-select v-model="editStatusForm.status" placeholder="请选择订单状态" style="width: 100%" clearable>
                        <el-option
                            v-for="item in optionStatus"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>


                <el-row>
                    <el-form-item label="配送方式" prop="deliver" size="mini" v-if ="editStatusForm.status === 20">
                        <el-radio-group v-model="editStatusForm.delivery">
                            <el-radio label="三方物流" ></el-radio>
                            <el-radio label="自配送" ></el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item label="物流公司" prop="company" v-if ="editStatusForm.status === 20&&editStatusForm.delivery==='三方物流'">
                        <el-input v-model="editStatusForm.company" placeholder="请输入物流公司" size="mini" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="物流单号" prop="deliveryNo" v-if ="editStatusForm.status === 20&&editStatusForm.delivery==='三方物流'">
                        <el-input v-model="editStatusForm.deliveryNo" placeholder="请输入物流单号" size="mini" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="送货人员" prop="deliver" v-if ="editStatusForm.status === 20&&editStatusForm.delivery==='自配送'">
                        <el-input v-model="editStatusForm.deliver" placeholder="请输入送货人员姓名" size="mini" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="手机号" prop="phone" v-if ="editStatusForm.status === 20&&editStatusForm.delivery==='自配送'">
                        <el-input v-model="editStatusForm.phone" placeholder="请输入送货人员手机号" size="mini" clearable></el-input>
                    </el-form-item>

                </el-row>



<!--                <el-form-item label="物流单号" prop="deliveryNo" v-if="editStatusForm.status === 20">-->
<!--                    <el-input v-model="editStatusForm.deliveryNo" placeholder="请输入物流单号" size="mini" clearable></el-input>-->
<!--                </el-form-item>-->
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogEditStatusVisible = false" size="mini">取 消</el-button>
                <el-button type="primary" @click="handleEditStatus" size="mini">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="交票信息" :visible.sync="dialogInvoice" width="400px">
            <el-form ref="invoiceForm" :model="invoiceForm" :rules="rules" label-width="90px" size="mini">
                <el-form-item label="采购订单号" prop="order">
                    <el-input v-model="invoiceForm.order" placeholder="请输入订单编号" size="mini" disabled clearable></el-input>
                </el-form-item>
                <el-form-item label="采购订单号" prop="price">
                    <el-input v-model="invoiceForm.price" placeholder="请输入订单编号" size="mini" disabled clearable></el-input>
                </el-form-item>
                <el-form-item label="发票号" prop="invoice">
                    <el-input v-model="invoiceForm.invoice" placeholder="请输入发票号" size="mini" clearable></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogInvoice = false" size="mini">取 消</el-button>
                <el-button type="primary" @click="handleInvoice" size="mini">确 定</el-button>
            </div>
        </el-dialog>

    </div>
</template>
<script>
import { downloadByPost, convertRes2Blob } from '../../utils/download.js';
const HEIGHT_OFFSET = 118;
import RightToolBar from "../../components/RightToolBar";
import Sortable from "sortablejs";

export default {
    components:{RightToolBar},
    data() {
        return {
            dialogInvoice:false,
            invoiceForm: {
                ids: [],
                id: "",
                order: "",
                invoice: "",
            },
            showSearch:false,
            updateTable:"pTable",
            dropCol:[
                {id:"0",label:'采购合同号',prop:'saleOrder',isShow:true},
                {id:"1",label:'订单号',prop:'orderNo',isShow:true},
                {id:"2",label:'采购订单号',prop:'order',isShow:true},
                {id:"3",label:'供应商订单号',prop:'supplierOrder',isShow:true},
                {id:"4",label:'客户订单号',prop:'customerOrderId',isShow:true},
                {id:"5",label:'采购方',prop:'purchaser',isShow:true},
                {id:"6",label:'收货人',prop:'consignee',isShow:true},
                {id:"7",label:'收货人电话',prop:'mobile',isShow:true},
                {id:"8",label:'收货地址',prop:'address',isShow:true},
                {id:"9",label:'未税总价(元)',prop:'untaxedPrice',isShow:true},
                {id:"10",label:'含税总价(元)',prop:'price',isShow:true},
                {id:"11",label:'发票状态',prop:'isInvoice',isShow:true},
                {id:"12",label:'发票号',prop:'invoice',isShow:true},
                {id:"13",label:'下单时间',prop:'createTime',isShow:true},
                {id:"14",label:'状态',prop:'status',isShow:true},
                {id:"15",label:'操作',prop:'op',isShow:true}],
            tableConfig: {
                height: 0,
            },
            reviewVisible:false,
            companys:[],
            searchForm: {
                companyId: "",
                timeDate: "",
                status: "",
                deliveryNo: "",
                consignee: "",
                orderNo: "",
                orderNo1: "",
                id: "",
                customerOrderId: "",
            },
            searchFormExport: {},
            loading: false,
            total: 0,
            pageSize: 10,
            currentPage: 1,
            tableData: [],

            addOrderForm: {
                id: "",
                orderBatch: "",
            },
            exportOrderVisible: false,
            exportOrderForm: {
                orderBatch: "",
            },
            visibleUploadDeliver: false,
            uploadDeliverPOId: "",
            dialogImageUrl: '',
            dialogPreviewVisible: false,
            deliverImages: [],

            dialogEditStatusVisible: false,
            editStatusForm: {
                id: "",
                order: "",
                status: 0,
                deliveryNo: "",
                delivery: "",
                deliver: "",
                phone: "",
                company: "",
            },
            optionStatus: [{
                value: 10,
                label: '已下单',
            },{
                value: 11,
                label: '已接单',
            },{
                value: 20,
                label: '已发货',
            // },{
            //     value: 21,
            //     label: '部分发货',
            },{
                value: 30,
                label: '妥投',
            // },{
            //     value: 31,
            //     label: '部分妥投',
            },{
                value: 40,
                label: '拒收',
            // },{
            //     value: 41,
            //     label: '部分拒收',
            },],
            rules: {
                address: [
                    { required: true, message: '请输入详细地址', trigger: 'blur' }
                ],
                consignee: [
                    { required: true, message: '请输入收件人', trigger: 'blur' }
                ],
                mobile: [
                    { required: true, message: '请输入联系电话', trigger: 'blur' }
                ],

            },
            pageLoadng: undefined,
            reviewForm: {
                id:"",
                companyId:"",
                invoiceId:"",
                companyName:"",//
                bankName:"",//
                bankAccount:"",//
                companyTaxNo:"",//
                registeredTel:"",//
                registeredAddress:"",//

            },
            addressId:"",
            addressForm: {
                region: {
                    province: '',
                    city: '',
                    area: '',
                    town:""
                },
                id:"",
                mobile:"",
                address:"",//
                consignee:"",//
                county:"",//
                city:"",//
                province:"",//
                provinceId:"",//
                cityId:"",//
                countyId:""//

            },
            selectData:[],
            addressList:[],
            invoiceList:[],
            money: 0,
        }
    },
    methods: {

        loadDetail(id) {
            const that = this;
            this.$axios.get("/admin/purchaseOrder/detail/" + id)
                .then(function(response) {
                    let resp = response.data;
                    if( resp.header.status == 0) {
                        that.selectData = resp.data;
                        that.selectData.map(it => {that.money = that.money+it.totalPrice});
                        if(that.money){
                            that.money = that.money.toFixed(2);
                        }
                    }
                }).finally(() => {

            });
        },
        loadAddress(){
            let _this = this
            this.$axios.get("/admin/address/getAddress"
            ).then(function (response) {
                let resp = response.data;
                if (resp.header.status == 0) {
                    _this.addressList = resp.data;
                }

            });

        } ,
        regionChange (data) {

            //{"province":{"key":"130000","value":"河北省"},"city":{"key":"130100","value":"石家庄市"},"area":{"key":"130105","value":"新华区"}}

            if(data.province != null){
                this.addressForm.province = data.province.value;
                this.addressForm.provinceId = data.province.key;
            }

            if(data.city != null){
                this.addressForm.city = data.city.value;
                this.addressForm.cityId = data.city.key;
            }
            if(data.area != null){
                this.addressForm.county = data.area.value;
                this.addressForm.countyId = data.area.key;
            }

        },
        addressChanged(addressId) {
            this.addressId = '';
            this.addressId = addressId;
            //this.$set(this.addressForm, 'id', '')
            // this.$set(this.addressForm,'id',addressId);
            // this.$forceUpdate();
            if(addressId != null && addressId != ""){

                let one = null;
                for(let i=0;i<this.addressList.length;i++){
                    let item = this.addressList[i];
                    if(item.id == addressId){
                        one = item;
                    }
                }
                if(one != null){
                    this.addressForm = one;
                    let region = {};
                    if(one.provinceId != null){
                        region.province = one.provinceId;
                    }
                    if(one.cityId != null){
                        region.city = one.cityId;
                    }
                    if(one.countyId != null){
                        region.area = one.countyId;
                    }
                    region.town = '';
                    this.addressForm.region = region;
                }


            }else{

                // this.addressForm.id = addressId;
                // this.addressForm.region = {province:"",city:"",area:"",town:""};
                // this.$set(this.addressForm, this.addressForm.id, '');
                this.addressForm = {
                    region: {
                        province: '',
                        city: '',
                        area: '',
                        town:""
                    },
                    id:"",
                    mobile:"",
                    address:"",//
                    consignee:"",//
                    county:"",//
                    city:"",//
                    province:"",//
                    provinceId:"",//
                    cityId:"",//
                    countyId:""//

                }


            }
            //this.$set(this.addressForm,'id',addressId);

        },
        selectChanged(invoiceId) {
            if(invoiceId != null && invoiceId != ""){

                let one = null;
                for(let i=0;i<this.invoiceList.length;i++){
                    let item = this.invoiceList[i];
                    if(item.id == invoiceId){
                        one = item;
                    }
                }
                if(one != null) {
                    this.reviewForm = one;
                    this.reviewForm.invoiceId = invoiceId;
                }

            }else{
                this.reviewForm = {};
                this.reviewForm.invoiceId = "";
            }

        },
        loadInvoice(){
            let _this = this
            this.$axios.post("/admin/invoice/customer/list"
            ).then(function (response) {
                let resp = response.data;
                if (resp.header.status == 0) {
                    _this.invoiceList = resp.data;
                }

            });

        } ,
        //重绘表格
        reDrawTable() {
            this.updateTable = "pTable"+Math.random();
            this.$nextTick(()=>{
                this.columnDrop();


            });

        },

        doSearch() {
            this.currentPage=1;
            this.onSearch();
        },
        handleToDeliveryNote(row) {
            this.$router.push({ name: "jcyDeliveryNote", params: { title:'京采云送货单' }, query: { id: row.orderId } });
        },
        formatDateTime(date, format) {
            const o = {
                "M+": date.getMonth() + 1, // 月份
                "d+": date.getDate(), // 日
                "h+": date.getHours() % 12 === 0 ? 12 : date.getHours() % 12, // 小时
                "H+": date.getHours(), // 小时
                "m+": date.getMinutes(), // 分
                "s+": date.getSeconds(), // 秒
                "q+": Math.floor((date.getMonth() + 3) / 3), // 季度
                S: date.getMilliseconds(), // 毫秒
                a: date.getHours() < 12 ? "上午" : "下午", // 上午/下午
                A: date.getHours() < 12 ? "AM" : "PM", // AM/PM
            };
            if (/(y+)/.test(format)) {
                format = format.replace(
                RegExp.$1,
                (date.getFullYear() + "").substr(4 - RegExp.$1.length)
                );
            }
            for (let k in o) {
                if (new RegExp("(" + k + ")").test(format)) {
                format = format.replace(
                    RegExp.$1,
                    RegExp.$1.length === 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
                );
                }
            }
            return format;
        },
        onSearch() {

            const that = this;
            const cond = {...this.searchForm};
            Object.keys(cond).forEach(key => {
                if(cond[key] instanceof Array) {
                    if(cond[key].length === 0) {
                        delete cond[key];
                    } else if(!cond[key]) {
                        delete cond[key];
                    }
                } else if(!cond[key]) {
                    delete cond[key];
                }
            })
            if(cond['orderDate']) {
                const orderDate = cond['orderDate']
                delete cond['orderDate'];
                cond['orderDateStart'] = this.formatDateTime(orderDate[0], "yyyy-MM-dd");
                cond['orderDateEnd'] = this.formatDateTime(orderDate[1], "yyyy-MM-dd");
            }
            this.searchFormStash = {...cond};
            this.loading = true;
            this.$axios.post("/admin/purchaseOrder/search",{
                cond,
                page: this.currentPage - 1,size:this.pageSize
            }).then(function(response) {
                let resp = response.data;
                if( resp.header.status == 0) {
                    that.tableData = resp.data.content;
                    that.total = resp.data.totalElements;
                }
            }).finally(() => {
                that.loading = false;
            });
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogPreviewVisible = true;
        },
        onUploadSuccess(resp, file) {
            const { data } = resp;
            if(data === '上传失败') {
                return;
            }
            this.deliverImages = [...this.deliverImages, {name: file.name, url: data}];

        },
        onPageChange(currentPage) {
            this.currentPage = currentPage;
            this.onSearch();
        },
        onSizeChange(val) {
            this.pageSize = val;
            this.onSearch();
        },
        handleToReviewDetail(row) {
            this.$router.push({name: "purchaseOrderDetail", params:{title:'采购订单详情',id: row.id}});
        },
        handleSelectionChange(val) {
            this.selectData = val;
        },
        handleToDeliver(row) {
            this.$router.push({name: "supplierPODeliver",  params: {title:'签收单',info:row.id,id: row.id}});
        },
        handleUploadDeliver(row) {
            const that = this;
            this.deliverImages = [];
            this.uploadDeliverPOId = row.id;
            this.$axios
            .get("/admin/purchaseOrder/getDeliverImages/" + row.id)
            .then((resp) => {
                const { data } = resp.data;
                that.deliverImages = data.map(it => ({name: it.filename, url: it.path}));
            });
            this.visibleUploadDeliver = true;
        },
        handleShowInvoiceDialog(row) {
            this.invoiceForm.ids = [],
            this.invoiceForm.id = row.id;
            this.invoiceForm.order = row.order;
            this.invoiceForm.price = row.price;
            this.invoiceForm.invoice = row.invoice;
            this.dialogInvoice = true;
        },
        handleShowSelectedInvoiceDialog() {
            if(!this.selectData || this.selectData.length === 0) {
                this.$notify.error({
                    title: '错误',
                    message: '请先选择订单'
                });
                return;
            }
            const hasInvoice = this.selectData.filter(it => it['invoice']).map(it => it['order']);
            if(hasInvoice.length > 0) {
                this.$notify.error({
                    title: '错误',
                    message: '已有发票的订单不能批量交票'
                });
                return;
            }
            this.invoiceForm.ids = this.selectData.map(it => it['id']);
            this.invoiceForm.id = '';
            this.invoiceForm.order = this.selectData.map(it => it['order']).join(',');
            this.invoiceForm.price = this.selectData.map(it => it['price']).reduce((prev, cur) => {
                return prev + cur;
            });
            this.invoiceForm.invoice = '';
            this.dialogInvoice = true;
        },
        handleInvoice() {
            const that = this;
            const ids = this.invoiceForm.ids && this.invoiceForm.ids.length > 0 ? this.invoiceForm.ids : [this.invoiceForm.id];
            this.$axios
                .post("/admin/purchaseOrder/updateInvoice", {ids, invoice: this.invoiceForm.invoice})
                .then((response) => {
                    let resp = response.data;
                    if(resp.header.status !== 0) {
                        that.$notify.error({
                            title: '错误',
                            message: resp.header.msg
                        });
                        return;
                    }
                    that.onSearch();
                    this.dialogInvoice = false;
                });
        },
        handleShowEditStatusDialog(row) {
            this.editStatusForm.id = row.id;
            this.editStatusForm.order = row.order;
            this.editStatusForm.status = row.status;
            this.editStatusForm.delivery = row.delivery;
            this.editStatusForm.deliveryNo = row.logisticsNo;
            this.editStatusForm.company = row.company;
            this.editStatusForm.deliver = row.operator;
            this.editStatusForm.phone = row.phone;
            // if(row.delivery && row.delivery == "三方物流"){
            //     this.editStatusForm.deliver = "";
            //     this.editStatusForm.phone == "";
            // }
            // if(row.delivery && row.delivery == "自配送"){
            //     this.editStatusForm.deliveryNo = "";
            //     this.editStatusForm.company == "";
            // }
            this.dialogEditStatusVisible = true;

        },
        handleEditStatus() {
            const that = this;
            if(this.editStatusForm.status == 20 &&  (this.editStatusForm.delivery  == null||this.editStatusForm.delivery == '')){
                that.$notify.error({
                    title: '提示',
                    message: '请选择配送方式'
                });
                return;
            }

            if(this.editStatusForm.status == 20 &&  this.editStatusForm.delivery == '自配送'){
                if(this.editStatusForm.deliver==''){
                    that.$notify.error({
                        title: '提示',
                        message: '请填写送货人员姓名'
                    });
                    return;
                }
                if(this.editStatusForm.phone==''){
                    that.$notify.error({
                        title: '提示',
                        message: '请填写送货人员手机号'
                    });
                    return;
                }

            }
            if(this.editStatusForm.status == 20 &&  this.editStatusForm.delivery == '三方物流'){
                if(this.editStatusForm.company==''){
                    that.$notify.error({
                        title: '提示',
                        message: '请填写物流公司'
                    });
                    return;
                }
                if(this.editStatusForm.deliveryNo==''){
                    that.$notify.error({
                        title: '提示',
                        message: '请填写物流单号'
                    });
                    return;
                }

            }
            this.$axios
            .post("/admin/purchaseOrder/updateStatus", this.editStatusForm)
            .then((response) => {
                let resp = response.data;
                if(resp.header.status !== 0) {
                    that.$notify.error({
                        title: '错误',
                        message: resp.header.msg
                    });
                    return;
                }
                that.onSearch();
                this.dialogEditStatusVisible = false;
            });
        },
        exportProcurementContract(id){
            this.pageLoadng = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            downloadByPost({
                axios: this.$axios,
                url: '/admin/product/order/exportPurchaseContract/' + id,
                success: response => {
                    convertRes2Blob(response);
                },
                faild: () => {
                    this.$message({
                        type: 'error',
                        message: '合同导出失败',
                        duration: 2000
                    });
                },
                complete: () => {
                    this.pageLoadng.close();
                    this.pageLoadng = undefined;
                }
            });
        },
        setTableHeight() {
            const tablePosition = this.$refs['tablePosition'];
            const {top} = tablePosition.getBoundingClientRect();
            this.tableConfig.height = window.innerHeight - top - HEIGHT_OFFSET;
        },
        //列拖拽
        columnDrop(){
            try{
                //const wrapperTr = this.$refs.purchaseTable.$el.querySelector('.el-table__header-wrapper tr');
                const wrapperTr = document.querySelector('.el-table__header-wrapper tr');
                let oldLabel;
                let newLabel;
                let oldIndex;
                let newIndex;
                let count=0;
                const that=this;
                this.sortable = Sortable.create(wrapperTr, {
                    animation: 180,
                    delay: 30,
                    draggable:".drag",
                    onEnd: evt => {

                        oldLabel=this.$refs.purchaseTable.columns[evt.oldIndex].property;
                        newLabel=this.$refs.purchaseTable.columns[evt.newIndex].property;
                        for (let i=0;i<that.dropCol.length;i++){
                            if (that.dropCol[i].prop!=undefined&&that.dropCol[i].prop==newLabel)
                                newIndex=i;

                        }

                        for (let j=0;j<that.dropCol.length;j++){
                            if (that.dropCol[j].prop!=undefined&&that.dropCol[j].prop==oldLabel)
                                oldIndex=j;
                        }

                        const oldItem = this.dropCol[oldIndex];
                        this.dropCol.splice(oldIndex, 1);
                        this.dropCol.splice(newIndex, 0, oldItem);

                        this.dropCol.forEach((item)=>{
                            if(item.prop==newLabel||item.prop==oldLabel){
                                item.id=new Date().getTime() + (++count)+"";
                                //console.log(JSON.stringify(this.dropCol));// eslint-disable-line
                            }
                        })



                    },
                });
            }catch (e) {
                console.log(e);// eslint-disable-line
            }
        },
        loadCompanys(){
            let _this = this
            this.$axios.post("/admin/company/purchaseCompanies"
            ).then(function (response) {
                let resp = response.data;
                if (resp.header.status == 0) {
                    _this.companys = resp.data;
                }

            });

        },
        exportOrderDialogNew(command) {
            let data = {};
            let url = "/admin/purchaseOrder/exportOrder";
            switch(command) {
                case 'all': {
                    data = {cond: {...this.searchFormStash}};
                    break;
                }
                case 'selected': {
                    if (this.selectData.length == 0) {
                        this.$message({
                            type: 'error',
                            message: '请选择要导出的订单',
                            duration: 2000
                        });
                        return;
                    }
                    data = {ids: this.selectData.map(it => it.id)};
                    // const that = this;
                    // let arr = [];
                    // let val = this.selectData;
                    // if (val.length > 0) {
                    //     for (let i = 0; i < val.length; i++) {
                    //         arr.push(val[i].id);
                    //     }
                    // }
                    break;
                }
                case 'supplier': {
                    url = '/admin/purchaseOrder/exportSupplierOrder';
                    if (this.selectData.length == 0) {
                        this.$message({
                            type: 'error',
                            message: '请选择要导出对账单的订单',
                            duration: 2000
                        });
                        return;
                    }
                    data = {ids: this.selectData.map(it => it.id)};

                    break;
                }
            }
            this.loading = true;
            downloadByPost({
                axios: this.$axios,
                url: url,
                data,
                success: response => {
                    convertRes2Blob(response);
                },
                complete: () => {
                    this.loading = false;
                }
            });
        },
    },
    mounted() {
        this.pageLoadng = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        });
        setTimeout(() => {
            this.setTableHeight();
            this.pageLoadng.close();
            this.pageLoadng = undefined;
        }, 500);
        this.columnDrop();

    },
    beforeDestroy() {
        if(this.pageLoadng) {
            this.pageLoadng.close();
            this.pageLoadng = undefined;
        }
    },
    created() {
        this.onSearch();
        this.loadCompanys();
        window.addEventListener("resize", this.setTableHeight);
    },
}
</script>
<style>

    .item {

        margin-bottom: 0px;

    }
    .item1 {
        margin-top: -10px;
        margin-bottom: 0px;

    }
</style>
